<template>
  <div class="main-container" @click="setBarcodeHidden">
    <hd-header ref="header"></hd-header>
    <div class="main">
      <router-view/>
    </div>
    <hd-footer></hd-footer>
     <el-dialog
      title=""
      :visible.sync="isBarcodeShow"
      width="360px"
      @close="showBarcode"
    >
      <div id="Qcode" class="barcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'Layout',
  components: {
    HdHeader: Header,
    HdFooter: Footer
  },
  data () {
    return {
      join: false
    }
  },
  methods: {
    showBarcode () {
      this.$store.commit('SET_BARCODESHOW', false)
      if (this.$route.path.indexOf('/video') !== -1) {
        var pathInfo = JSON.parse(localStorage.getItem('fromPath'))
        if (pathInfo.query) {
          this.$router.push({path: pathInfo.path, query: {keyword: pathInfo.query.keyword}})
        } else {
          this.$router.push(pathInfo.path)
        }
        localStorage.removeItem('fromPath')
      } else {
        this.$router.push('/')
      }
      // this.$router
    },
    setBarcodeHidden () {
      this.$refs.header.isBarcodeShow = false
    }
  },
  watch: {
    isBarcodeShow (newVal, oldVal) {
      if (newVal === true) {
        setTimeout(() => {
          // debugger
          // eslint-disable-next-line
          const obj = new WxLogin({
            id: 'Qcode',
            // appid: 'wx48c8723687d02f25',
            appid: 'wx41c67f7534adc317',
            scope: 'snsapi_login',
            // 这里填三方
            redirect_uri: encodeURI(
              'https://oauth.histomed.com/hdauth/loginTest.html?original=' +
                window.location
            ),
            state: '',
            style: '',
            href: ''
          })
        }, 100)
      }
    }
  },
  computed: {
    isBarcodeShow: {
      get () {
        return this.$store.state.isBarcodeShow
      },
      set (val) {
        this.join = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-container{
  overflow: hidden;
}
.main {
  margin-top:89px;
  overflow: hidden;
  /* min-height: 1500px; */
}
.barcode {
  display: flex;
  justify-content: center;
}
/deep/ .el-dialog {
  height: 470px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/layoutHf.vue